import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

import { publicRoutes } from 'pages/constants/publicRoutes';
import { getCurrentLanguage } from 'modules/language/selectors/language';
import { sessionInitialized } from 'modules/session/selectors/sessionStatus';

const propTypes = {
  component: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  renderCondition: PropTypes.bool.isRequired,
  isSessionInitialized: PropTypes.bool.isRequired,
  shouldRedirectToHomeAuthorizedUser: PropTypes.bool,
  redirectPath: PropTypes.string,
};

const defaultProps = {
  shouldRedirectToHomeAuthorizedUser: false,
  redirectPath: '',
};

const CustomRoute = ({
  component: Component,
  location,
  renderCondition,
  isSessionInitialized,
  redirectPath,
  shouldRedirectToHomeAuthorizedUser,
  ...rest
}) => (
  <Route
    { ...rest }
    render={ props => {
      const { pathname } = location;
      const path = pathname.split('/').pop();
      const shouldRedirectToHome = localStorage.getItem('jwt')
        && isSessionInitialized
        && (publicRoutes.includes(path) || !path);

      if (shouldRedirectToHomeAuthorizedUser && shouldRedirectToHome) {
        return <Redirect to={ `/${ getCurrentLanguage() }/appointments` } />;
      }

      if (renderCondition) {
        return <Component { ...props } />;
      }

      return <Redirect to={ `/${ getCurrentLanguage() + redirectPath }` } />;
    } }
  />
);


CustomRoute.propTypes = propTypes;
CustomRoute.defaultProps = defaultProps;

export default connect(
  (state, { renderCondition }) => ({
    isSessionInitialized: sessionInitialized(state),
    renderCondition: !renderCondition || renderCondition(state),
  }),
)(CustomRoute);
